import React, { FunctionComponent, useMemo } from 'react';
import { Layout } from '@/components/Layout';
import BestTechnology from '@/components/Solutions/BestTechnology/BestTechnology';
import ForOrganisations from '@/components/Solutions/ForOrganisations/ForOrganisations';
import TurnkeySolutions from '@/components/Solutions/TurnkeySolutions/TurnkeySolutions';
import StartOptionsSection from '@/components/Visas/Common/StartOptionsSection/StartOptionsSection';
import { StartOption } from '@/components/Visas/VisaPage';
import { Container } from '@visalex/core';

import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import styles from '@/components/Solutions/SolutionsPage.module.scss';

const SolutionsPage: FunctionComponent = () => {
  const { t, i18n } = useTranslation();
  const startOptions = useMemo(
    () => ({
      title: t('solutions.start-options.title'),
      options: t('solutions.start-options.options', { returnObjects: true }) as StartOption[],
    }),
    [i18n.language]
  );

  return (
    <Layout title={t('solutions.seo-title')} description={t('solutions.seo-description')}>
      <div className={styles['solutions-background']}>
        <Container className={styles.solutions}>
          <ForOrganisations />
          <TurnkeySolutions />
          <BestTechnology />
          <section className={styles['solutions__start-options-section']}>
            <StartOptionsSection startOptions={startOptions.options} title={startOptions.title} />
          </section>
        </Container>
      </div>
    </Layout>
  );
};

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale)),
    },
  };
}

export default SolutionsPage;
